module.exports = __webpack_public_path__ + "img/Meta4pro-bg.b6253f28.jpg";